import { truncateString } from "helpers/system";
import React, { useState } from "react";

const ToggleComp = (props) => (
    <span className="link" onClick={props.onClick}>
        {props.text}
    </span>
);

const defaultProps = {
    ClosedWrapper: (props) => props.children,
    OpenedWrapper: (props) => props.children,
    truncateLength: 200,
    showedLength: 300,
};

const TruncatedString = (props) => {
    const [showFull, setShowFull] = useState(false);
    const { ClosedWrapper, OpenedWrapper, text, showedLength, truncateLength, omission } = {
        ...defaultProps,
        ...props,
    };
    if (!text || !text.length) {
        return null;
    }
    const toggleItem = (e, value) => {
        e.preventDefault();
        e.stopPropagation();
        setShowFull(value);
    };
    return text.length > showedLength && !showFull ? (
        <ClosedWrapper>
            {truncateString(text, truncateLength, omission || "...")}&nbsp;
            <ToggleComp onClick={(e) => toggleItem(e, true)} text="Развернуть" />
        </ClosedWrapper>
    ) : (
        <OpenedWrapper>
            {text}
            {showFull && (
                <>
                    &nbsp;
                    <ToggleComp onClick={(e) => toggleItem(e, false)} text="Свернуть" />
                </>
            )}
        </OpenedWrapper>
    );
};
export default TruncatedString;
